import { render, staticRenderFns } from "./DeleteApplication.vue?vue&type=template&id=ca2fa4c8"
import script from "./DeleteApplication.vue?vue&type=script&lang=js"
export * from "./DeleteApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports